export default __webpack_public_path__ + "static/media/graphic-6.c91a032c.png";